<template>
  <mu-button @click.stop.prevent="onClick" class="pointer-cursor" :small="small" icon>
    <mu-icon :value="value ? 'star' : 'star_border'" />
  </mu-button>
</template>

<script>
export default {
  name: "BookmarkButton",
  components: {
    
  },
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    object: {
      type: Object,
      default: function() {
        return {};
      }
    },
    reference: {
      type: Object,
      default: function() {
        return {};
      }
    },
  },
  data() {
    return {
      
    }
  },
  computed: {
    staffId() {
      return this.$store.state.staff.id;
    },
    value: {
      get() {
        var exist = this.$store.state.bookmarks.find(item => item.id === this.id && item.type === this.type);
        if(typeof exist === 'undefined') {
          return false;
        } else {
          return true;
        }
      },
      set(payload) {
        if(payload) {
          this.$store.dispatch('bookmarkUp', {
            id: this.id,
            type: this.type,
            object: this.object,
            reference: this.reference
          });
        } else {
          this.$store.dispatch('bookmarkDown', {
            id: this.id,
            type: this.type,
            object: this.object,
            reference: this.reference
          });
        }
      }
    }
  },
  methods: {
    onClick() {
      this.value = !this.value;
    },
  },
  watch: {
    
  }
}
</script>

<style scoped>
.pointer-cursor {
  cursor: pointer;
  text-align: center;
}
</style>
